import cx from 'classnames';
import { AcceptTermsModal } from 'components/glamstar/AcceptTermsModal';
import { Modal } from 'components/modal/Modal';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';
import { PartnerInfoActions } from 'state/actions/user/PartnerInfoActions';

import styles from './styles.module.scss';

dayjs.extend(isBetween);

export class GlamstarChallenges extends Component {
  PAYMENT_CHALLENGE_TYPE = 12;
  challengeTriggered = null;

  history = this.props.history;

  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      pageSize: 20,
      showModal: false,
      challenges: [],
    };
  }

  currentDateIsBeforeDateFrom = dateFrom => {
    return dayjs().isBefore(dateFrom);
  };

  currentDateIsAfterDateFrom = dateFrom => {
    return dayjs().isAfter(dateFrom);
  };

  currentDateIsAfterDateTo = dateTo => {
    return dayjs().isAfter(dateTo);
  };

  currentDateIsBetweenDates = (dateFrom, dateTo) => {
    // '[]' includes start and end date
    const includesStartAndEndDate = '[]';

    return dayjs().isBetween(dateFrom, dateTo, 'days', includesStartAndEndDate);
  };

  handleConfirmTerms = () => {
    this.confirmTerms(this.challengeTriggered);
  };

  confirmTerms = async campaign => {
    await ExecuteRequest(
      GlamboxEndpoints.Partner.acceptGlamstarTerms,
      null,
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode !== 200) {
          this.props.publishErrorAlert(result.message);
          return;
        }
        this.history.push(
          `/glampartner/glamstar/desafio/${campaign.campaignId}`,
          {
            canAccess: campaign.enable,
          }
        );
      }
    );
  };

  getCampaigns = async () => {
    const { currentPage, pageSize } = this.state;
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getCampaigns,
      {
        page: currentPage - 1,
        pageSize,
        paymentType: this.PAYMENT_CHALLENGE_TYPE,
      },
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { statusCode, result } = response;

        if (statusCode === 200) {
          const challenges = result.campaigns
            .map(campaign => {
              const { dateFrom, dateTo } = campaign;
              const todayIsBetweenBothDates = this.currentDateIsBetweenDates(
                dateFrom,
                dateTo
              );

              return {
                ...campaign,
                comingSoon: this.currentDateIsBeforeDateFrom(dateFrom),
                enable: true,
                formattedDateFrom: new Intl.DateTimeFormat('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                }).format(new Date(campaign.dateFrom)),
                formattedDateTo: new Intl.DateTimeFormat('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                }).format(new Date(campaign.dateTo)),
              };
            })
            .sort((a, b) => a.campaignId - b.campaignId);

          this.setState({
            challenges,
          });
        } else {
          this.props.publishErrorAlert('Houve um erro ao carregar os desafios');
        }
        this.props.loaderHide();
      }
    );
  };

  subscribe = async campaign => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Partner.subscribeChallenge,
      {
        campaignId: campaign.campaignId,
      },
      'POST',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.props.publishSuccessAlert('Inscrição realizada com sucesso');
          this.getCampaigns();
        } else {
          this.props.publishErrorAlert(result.message);
        }

        this.props.loaderHide();
      }
    );
  };

  handleNavigateToChallenge = campaign => {
    // if (!campaign.enable) {
    //   return;
    // }

    const { partnerInfo } = this.props.store;
    const { data } = partnerInfo;

    if (this.isEmptyObject(data)) {
      this.props.publishErrorAlert(
        'Houve um problema ao redirecionar para o desafio'
      );
      return;
    }

    this.challengeTriggered = campaign;
    console.log(campaign)

    const { acceptGlamstar } = data;
    
    if (!acceptGlamstar) {
      this.setState({
        showModal: true,
      })
      
      return;
    }

    if (campaign.title.includes("11º")) {
      this.history.push(`/glampartner/glamstar/desafio/${campaign.campaignId}`, {
        canAccess: campaign.enable,
      });
    }
    else {
      this.history.push(`/glampartner/glamstar/desafio/oldchallenges/${campaign.campaignId}`,{
        canAccess: campaign.enable,
      })
    }
  };

  switchCampaignActionStatus = ({
    campaignMemberStatus,
    campaignStatus,
    dateTo,
    dateFrom
  }) => {
    const status = {
      name: '',
      color: '#6c757d',
    };

    if (!this.currentDateIsBetweenDates(dateFrom, dateTo) && !this.currentDateIsBeforeDateFrom(dateFrom)) {
      Object.assign(status, {
        color: '#FE357B',
        name: 'Encerrado',
      });
    } else if(campaignMemberStatus === 'Inscreva-se') {
      // if (campaignStatus === 'Campanha Encerrada' || (campaignStatus === 'Solicitar entregas')) {
      //   Object.assign(status, {
      //     color: '#6c757d',
      //     name: 'Inscrições encerradas',
      //   });
      // } else {
        Object.assign(status, {
          color: '#FE357B',
          name: 'Não inscrita',
        });
      //}
    } else if (campaignMemberStatus === 'Recusada') {
      Object.assign(status, {
        color: '#6c757d',
        name: 'Não classificada',
      });
    } else if (campaignMemberStatus !== 'Inscreva-se') {
      Object.assign(status, {
        color: '#77d16b',
        name: 'Inscrita',
      });
    }
    // else if (campaignMemberStatus === 'Concluído') {
    //   Object.assign(status, {
    //     color: '#FE357B',
    //     name: 'Aprovada',
    //   });
    // } else if (campaignMemberStatus === 'Em análise') {
    //   if (this.currentDateIsAfterDateTo(dateTo)) {
    //     Object.assign(status, {
    //       color: '#6c757d',
    //       name: 'Inscrições encerradas',
    //     });
    //   } else {
    //     Object.assign(status, {
    //       color: '#ebde59',
    //       name: 'Em análise',
    //     });
    //   }
    // } else if (campaignMemberStatus === 'Em avaliação') {
    //   if (!this.currentDateIsBetweenDates(dateFrom, dateTo)) {
    //     Object.assign(status, {
    //       color: '#FE357B',
    //       name: 'Encerrado',
    //     });
    //   } else {
    //     Object.assign(status, {
    //       color: '#FE357B',
    //       name: 'Enviado',
    //     });
    //   }
    // }
    // else if (campaignMemberStatus === 'Recusada') {
    //   Object.assign(status, {
    //     color: '#6c757d',
    //     name: 'Não classificada',
    //   });
    //}
    return status;
  };

  componentDidMount() {
    this.getCampaigns();
  }

  isEmptyObject = value => {
    if (!value) {
      return false;
    }

    return Object.keys(value).length === 0 && value.constructor === Object;
  };

  showStatus = ({ enable, dateTo }) => {
    if (enable || this.currentDateIsAfterDateTo(dateTo)) {
      return true;
    }
    return false;
  };

  _renderButton = campaign => {
    const {
      comingSoon,
      dateFrom,
      dateTo,
      campaignStatus,
      campaignMemberStatus,
    } = campaign;
    //console.log(`bora ver: ${campaignStatus} - ${campaignMemberStatus} - ${this.currentDateIsBetweenDates(dateFrom, dateTo)} - ${campaign.enable}`)

    if (campaignStatus === 'Selecionar Influenciadora') {
      if (this.currentDateIsBeforeDateFrom(dateFrom)) {
        if (campaignMemberStatus === 'Participando') {
          return (
            <button
            className={cx([
              styles.challengeButton,
              styles.seeMore,
              {
                [styles['challengeButton--hide']]: false,
              },
            ])}
              type="button"
              disabled={true}
              onClick={() => this.subscribe(campaign)}
              >
              {/* <i className={styles['subscribe__icon-green']}></i> */}
              Em breve
            </button>
          );
        }
      }
    }
    
    if (campaignStatus === 'Campanha iniciada') {
      if (this.currentDateIsBeforeDateFrom(dateFrom)) {
          return (
            <button
            className={cx([
              styles.challengeButton,
              styles.seeMore,
              {
                [styles['challengeButton--hide']]: false,
              },
            ])}
              type="button"
              disabled={true}
              onClick={() => this.subscribe(campaign)}
              >
              {/* <i className={styles['subscribe__icon-green']}></i> */}
              Em breve
            </button>
          );
      }
  }


    if (!this.currentDateIsBetweenDates(dateFrom, dateTo) && !this.currentDateIsBeforeDateFrom(dateFrom)) {
      return (
        <button
          className={cx([
            styles.challengeButton,
            styles.seeMore,
            {
              [styles['challengeButton--hide']]: false,
            },
          ])}
          type="button"
          onClick={() => this.handleNavigateToChallenge(campaign)}
        >
          {/* <i className={styles['seeMore__icon']}></i> */}
          ver
        </button>
      );
    }

    if (
      comingSoon && !this.currentDateIsBetweenDates(dateFrom, dateTo) &&
      (campaignStatus === 'Campanha iniciada' ||
        campaignStatus === 'Selecionar Influenciadora') &&
      (campaignMemberStatus === 'Inscreva-se' || campaignMemberStatus === 'Participando') 
    )
    {
      if(campaignMemberStatus === 'Inscreva-se' && campaign.title.includes("11º")) {
          return (
            <button
            className={cx([
              styles.challengeButton,
              styles.subscribe,
              {
                [styles['challengeButton--filledGreen']]: true,
              },
            ])}
            type="button"
            onClick={() => this.subscribe(campaign)}
            >
            {/* <i className={styles['subscribe__icon-green']}></i> */}
            {!campaign.title.includes("11º") ? "Inscreva-se" : "Não classificada" } 
          </button>
        );
      } else {
          return (
            <button
              className={cx([
                styles.challengeButton,
                styles.subscribe,
                {
                  [styles['challengeButton--green']]: true,
                },
              ])}
              type="button"
              disabled="true"
              onClick={() => this.subscribe(campaign)}
            >
              {/* <i className={styles['subscribe__icon-green']}></i> */}
              Inscrita  
            </button>
          );
      }
    }

    if (
      this.currentDateIsBetweenDates(dateFrom, dateTo) &&
      (campaignStatus === 'Campanha iniciada' ||
        campaignStatus === 'Selecionar Influenciadora') &&
      campaignMemberStatus === 'Inscreva-se'
    ) {

      const disable9Challenge = campaignMemberStatus === 'Inscreva-se' && campaign.title.includes("11º")
      return (
        <button
          className={cx([
            styles.challengeButton,
            styles.subscribe,
            {
              [styles['challengeButton--filledGreen']]: disable9Challenge ? false : true,
            },
          ])}
          type="button"
          disabled={disable9Challenge}
          onClick={() => this.subscribe(campaign)}
        >
          {/* <i className={styles['subscribe__icon']}></i> */}
          {!campaign.title.includes("11º") ? "Inscreva-se" : "Não classificada"}
        </button>
      );
    }

    const hideButton =
      comingSoon ||
      (campaignStatus === 'Campanha Encerrada' &&
        campaignMemberStatus === 'Inscreva-se');

    let buttonText = hideButton ? 'Finalizada' : 'Iniciar'

    const disableButton = campaignStatus === 'Solicitar entregas'
      && campaignMemberStatus === 'Inscreva-se'
      && this.currentDateIsBetweenDates(dateFrom, dateTo)
      && campaign.enable
    return (
      <button
        className={cx([
          styles.challengeButton,
          styles.seeMore,
          {
            [styles['challengeButton--hide']]: false,
          },
        ])}
        type="button"
        disabled={!campaign.enable || disableButton}
        onClick={() => this.handleNavigateToChallenge(campaign)}
      >
        {/* <i className={styles['seeMore__icon']}></i> */}
        { buttonText }
      </button>
    );
    
  };

  _renderDate = ({ comingSoon, formattedDateFrom, formattedDateTo }) => {
    if (comingSoon) {
      return 'Em breve';
    }
    return (
      <>
        <time>{formattedDateFrom}</time> até <time>{formattedDateTo}</time>
      </>
    );
  };

  _renderChallengeItem = campaign => {
    console.log('campanha',campaign)
    const status = this.switchCampaignActionStatus(campaign);

    let campaignIsActive = ((campaign.campaignStatus === 'Campanha iniciada' || campaign.campaignStatus === 'Selecionar Influenciadora') && campaign.campaignMemberStatus === 'Inscreva-se')

    return (
      <div
        className={cx(styles.challengeItem, {
          [styles['challengeItem--active']]: true,
        })}
        key={campaign.campaignId}
      >
        <aside>
          <strong className={styles.challengeTitle}>{campaign.title}</strong>
          <small className={styles.challengeDate}>
            {this._renderDate(campaign)}
          </small>

          {this.showStatus(campaign) && (
            <span
              className={styles.challengeStatus}
              style={{
                color: status.color,
              }}
            >
              {status.name}
            </span>
          )}
        </aside>

        {this._renderButton(campaign)}
      </div>
    );
  };

  render() {
    const { challenges, showModal } = this.state;
    const { partnerInfo } = this.props.store;

    if (this.isEmptyObject(partnerInfo?.data)) {
      this.props.publishErrorAlert('Houve um erro ao carregar a página');
      return null;
    }

    return (
      <div className={styles.container}>
        <header className={styles.concurseHeader}>
          <h1 className={styles.concurseTitle}>Nossos Challenges</h1>
        </header>

        <main className={styles.hero}>
          {
            challenges.map(item => this._renderChallengeItem(item))
          }
        </main>
        <Modal
          useDefaultDialog={false}
          visible={showModal}
          onCloseModal={() => this.setState({ showModal: false })}
          showCloseButton={false}
        >
          <AcceptTermsModal
            onCloseModal={() => this.setState({ showModal: false })}
            onConfirmTerms={this.handleConfirmTerms}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  setPartnerInfo: partnerInfo => {
    dispatch(PartnerInfoActions.set(partnerInfo));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

GlamstarChallenges = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamstarChallenges);
